import { create } from 'zustand';

interface ErrorStore {
  isVisibleModal: boolean;
  message: string;
  showModal(): void;
  closeModal(): void;
  setMessage(value: string): void;
}

export const useErrorStore = create<ErrorStore>((set) => ({
  isVisibleModal: false,
  message: '',
  showModal() {
    set((state) => ({
      ...state,
      isVisibleModal: true,
    }));
  },
  closeModal() {
    set((state) => ({
      ...state,
      isVisibleModal: false,
    }));
  },
  setMessage(value: string) {
    set((state) => ({ ...state, message: value }));
  },
}));
